// extracted by mini-css-extract-plugin
var _1 = "UserMenu-moduleUserMenu__iP37A";
export { _1 as "UserMenu" }
